/**
 * @generated SignedSource<<5f61624492e50d4217657beeb23555a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetTodoSummaryTodoChangedSubscription$variables = {
  teamIds: ReadonlyArray<string>;
};
export type WidgetTodoSummaryTodoChangedSubscription$data = {
  readonly todoChanged: {
    readonly category: {
      readonly id: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
        readonly notResolvedCount: number;
      }>;
    } | null;
  } | null;
};
export type WidgetTodoSummaryTodoChangedSubscription = {
  response: WidgetTodoSummaryTodoChangedSubscription$data;
  variables: WidgetTodoSummaryTodoChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategory",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "ids",
          "variableName": "teamIds"
        }
      ],
      "concreteType": "TodoCategoryTeam",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notResolvedCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetTodoSummaryTodoChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoChanged",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetTodoSummaryTodoChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoChanged",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7a655e6cb6a3d8a63c53111d2d7790e1",
    "id": null,
    "metadata": {},
    "name": "WidgetTodoSummaryTodoChangedSubscription",
    "operationKind": "subscription",
    "text": "subscription WidgetTodoSummaryTodoChangedSubscription(\n  $teamIds: [ID!]!\n) {\n  todoChanged(teamIds: $teamIds) {\n    category {\n      id\n      teams(ids: $teamIds) {\n        id\n        notResolvedCount\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ff825fbdd9e75a1d996fab27cd1fd30";

export default node;
